import CrudPage from '../../components/CrudPage'
import { monedasApi } from '../../api/entities'

// Monedas = Tipos del sistema (GET /tipos/tipo/monedas). Solo lectura (no se crean desde el producto).
export default function MonedasPage() {
  return (
    <CrudPage
      title="Monedas"
      api={monedasApi}
      readOnly
      searchable={false}
      columns={[
        { key: 'codigo', label: 'Código' },
        { key: 'descripcion', label: 'Descripción' },
      ]}
    />
  )
}
